import { useState, useEffect, useMemo, useRef } from "react";

import SepH from "./SepH";
import InputFloat from "./InputFloat";

import InputData from "../../components/InputData";
import Dropdown from "../../components/Dropdown";
import TooltipBox from "../../components/Tooltip";
import ButtonIconH from "../../components/ButtonIconH";
import InputSearch from "../../components/InputSearch";
import CheckBox from "../../components/CheckBox";

import { focusElement } from "../../js/utils";
import { post as rpost } from "../../support/utils/api";
import { post } from "../../js/post";
import { userData, selectedOptic } from "../../js/utils";
import { formatNumber } from "../utils/utils";

import DataTable from "react-data-table-component";
import moment from "moment";

import "../css/LoyaltyPopup.css";

const MAX_MOVEMENTS = 10;

const MOVEMENT_TYPES = {
  APM: "Asignación Puntos Manual",
  AT: "Puntos Bienvenida",
  PCV: "Puntos Canjeados Venta",
  PGV: "Puntos Generados Venta",
  PPD: "Puntos Perdidos Devolución",
};

export default ({
  show,
  idClient,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
  onUpdateLoyaltyPoints,
  onUpdateDto,
}) => {
  const [patientDto, setPatientDto] = useState("");
  const [patientDtoReasons, setPatientDtoReasons] = useState([]);
  const [patientDtoReasonsSel, setPatientDtoReasonsSel] = useState(null);
  const [pointsReasons, setPointsReasons] = useState([]);
  const [pointsReasonsSel, setPointsReasonsSel] = useState(null);
  const [loyId, setLoyId] = useState(-1);
  const [loyaltyId, setLoyaltyId] = useState("");
  const [newLoyaltyId, setNewLoyaltyId] = useState("");
  const [points, setPoints] = useState(-1);
  const [pointsConv, setPointsConv] = useState("");
  const [associatesTable, setAssociatesTable] = useState([]);
  const [showAddAssociate, setShowAddAssociate] = useState(false);
  const [addAssociate, setAddAssociate] = useState(null);
  const [movements, setMovements] = useState([]);
  const [movementsTable, setMovementsTable] = useState([]);
  const [showAllMovements, setShowAllMovements] = useState(false);
  const [pointsAdd, setPointsAdd] = useState(0);
  const [popupNewId, setPopupNewId] = useState(null);
  const [patientsFilter, setPatientsFilter] = useState([]);
  const [patientsFilterSel, setPatientsFilterSel] = useState(null);
  const [reasonsFilter, setReasonsFilter] = useState([]);
  const [reasonsFilterSel, setReasonsFilterSel] = useState(null);

  const inputIntRef = useRef();

  const associatesColumns = useMemo(
    () => [
      {
        name: "Código",
        selector: (row) => row.code,
        sortable: true,
        width: "13%",
        sortFunction: (a, b) => {
          const valueA = parseInt(a.code) || 0;
          const valueB = parseInt(b.code) || 0;
          return valueA - valueB;
        },
      },
      {
        name: "NIF",
        selector: (row) => row.nif,
        sortable: true,
        width: "13%",
      },
      {
        name: "Paciente",
        selector: (row) => row.patient,
        sortable: true,
        width: "35%",
      },
      {
        name: "Fecha de nacimiento",
        selector: (row) =>
          row.birthDate === ""
            ? ""
            : moment(row.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        sortable: true,
        width: "25%",
        sortFunction: (a, b) => {
          const aDate = a.birthDate || "";
          const bDate = b.birthDate || "";

          if (!aDate && !bDate) return 0;
          if (!aDate) return 1;
          if (!bDate) return -1;

          return (
            moment(a.birthDate, "YYYY-MM-DD") -
            moment(b.birthDate, "YYYY-MM-DD")
          );
        },
      },
      {
        name: "Titular",
        width: "10%",
        cell: (row) => (
          <div className="navtable-opt ntc-trash cash-voucher-popup">
            <div
              className="data-field c-pointer"
              onClick={() => onClickAssociate(row)}
            >
              <CheckBox active={row.holder} onClick={() => {}} />
            </div>
          </div>
        ),
        center: true,
      },
      {
        name: "",
        width: "4%",
        cell: (row) => (
          <div className="navtable-opt ntc-trash cash-voucher-popup">
            <img
              src="/images/remove-blue.svg"
              onClick={() => deleteAssociate(row.id)}
            />
          </div>
        ),
      },
    ],
    [associatesTable],
  );

  const movementsColumns = useMemo(
    () => [
      {
        name: "Código",
        selector: (row) => row.code,
        sortable: true,
        width: "6%",
        sortFunction: (a, b) => {
          const valueA = parseInt(a.code) || 0;
          const valueB = parseInt(b.code) || 0;
          return valueA - valueB;
        },
      },
      {
        name: "Paciente",
        selector: (row) => row.patient,
        sortable: true,
        width: "18%",
      },
      {
        name: "Operación",
        selector: (row) => row.operation,
        sortable: true,
        width: "7%",
        sortFunction: (a, b) => {
          const valueA = parseInt(a.operation) || 0;
          const valueB = parseInt(b.operation) || 0;
          return valueA - valueB;
        },
      },
      {
        name: "Óptica",
        selector: (row) => row.optic,
        sortable: true,
        width: "15%",
      },
      {
        name: "Descripción",
        selector: (row) => (
          <div
            className={`loyalty-movement-reason ${
              row.reason !== "" ? "loyalty-movement-has-reason" : ""
            }`}
          >
            <span
              data-tooltip-id={
                MOVEMENT_TYPES[row.description]
                  ? `loyalty-movement-type-${row.description}`
                  : undefined
              }
            >
              {row.description}
            </span>
            <span className="loyalty-movement-reason">{row.reason}</span>
          </div>
        ),
        sortable: true,
        width: "15%",
      },
      {
        name: "Agente",
        selector: (row) => row.agent,
        sortable: true,
        width: "15%",
      },
      {
        name: "Fecha",
        selector: (row) =>
          row.date !== ""
            ? moment(row.date, "YYYY-MM-DD HH:mm:ss").format(
                "DD/MM/YYYY HH:mm:ss",
              )
            : "",
        sortable: true,
        width: "12%",
        sortFunction: (a, b) => {
          const aDate = a.date || "";
          const bDate = b.date || "";

          if (!aDate && !bDate) return 0;
          if (!aDate) return 1;
          if (!bDate) return -1;

          return moment(a.date, "YYYY-MM-DD") - moment(b.date, "YYYY-MM-DD");
        },
      },
      {
        name: "Puntos",
        selector: (row) => formatNumber(row.points),
        sortable: true,
        width: "6%",
        sortFunction: (a, b) => {
          const valueA = parseInt(a.points) || 0;
          const valueB = parseInt(b.points) || 0;
          return valueA - valueB;
        },
      },
      {
        name: "Total",
        selector: (row) => formatNumber(row.total),
        sortable: true,
        width: "6%",
        sortFunction: (a, b) => {
          const valueA = parseInt(a.total) || 0;
          const valueB = parseInt(b.total) || 0;
          return valueA - valueB;
        },
      },
    ],
    [movementsTable],
  );

  const loadLoyalty = async (cId) => {
    const response = await rpost("Fidelizacion/ObtenerFidelizacion.php", {
      token: userData.token,
      idCliente: cId,
    });

    const associates = response.asociados.map((assoc) => {
      return {
        id: assoc.idAsociadoFidelizacion,
        patientId: assoc.idPaciente,
        code: assoc.codigoPaciente,
        nif: assoc.nif,
        patient: assoc.nombreApellidos,
        birthDate: assoc.fechaNacimiento,
        holder: assoc.titular == 1,
      };
    });

    const movements = response.movimientos.map((mov) => {
      return {
        id: mov.idMovimiento,
        code: mov.codigoPaciente,
        patient: mov.nombreApellidos,
        operation: mov.nOperacion == -1 ? "" : mov.nOperacion,
        optic: mov.nombreOptica,
        description: mov.tipoMovimiento,
        reason: mov.tipoMovimiento === "APM" ? mov.descripcion : "",
        agent: mov.empleado,
        date: mov.fecha + " " + mov.hora,
        points: mov.puntos,
        total: mov.total,
      };
    });

    movements.sort((a, b) => {
      if (b.date > a.date) return 1;
      if (b.date < a.date) return -1;
      return 0;
    });

    /*let movementsF = structuredClone(movements);
    movementsF = movementsF.slice(0, MAX_MOVEMENTS);*/

    setLoyId(response.idFidelizacion);
    setLoyaltyId(response.codigoFidelizacion);
    setPointsConv(response.totalPuntos);
    setAssociatesTable(associates);
    setMovements(movements);
    //setMovementsTable(movementsF);
    setNewLoyaltyId("");

    createPatientsFilter(movements);
    createReasonsFilter(movements);

    filterMovements(
      showAllMovements,
      movements,
      patientsFilterSel,
      reasonsFilterSel,
    );

    if (response.idFidelizacion !== "") {
      onUpdateLoyaltyPoints(response.totalPuntos);
    }
  };

  const loadDto = async (pDtoReasons) => {
    const response = await post("ObtenerDescuentoPaciente.php", {
      token: userData.token,
      idPaciente: idClient,
    });

    setPatientDto(response.descuento);
    const patientDto = pDtoReasons.find(
      (item) => item.text === response.motivoDescuento,
    );
    setPatientDtoReasonsSel(patientDto);
  };

  const loadScreen = async () => {
    let response = await post("support/Fidelizacion/ListarMotivosAPM.php", {
      token: userData.token,
    });

    const patientDtoReasonsN = response.map((item) => {
      return {
        id: item.id,
        text: item.descripcion,
      };
    });

    patientDtoReasonsN.unshift({
      id: "",
      text: "",
    });
    setPatientDtoReasons(patientDtoReasonsN);
    setPatientDtoReasonsSel(
      patientDtoReasonsN.length > 0 ? patientDtoReasonsN[0] : null,
    );

    /*response = await rpost(
      "Fidelizacion/ListarDescripcionesMovimientoFidelizacion.php",
      {
        token: userData.token,
      },
    );

    const pointsReasonsN = response.map((item) => {
      return {
        id: item.id,
        text: item.descripcion,
      };
    });

    pointsReasonsN.unshift({
      id: "",
      text: "",
    });
    setPointsReasons(pointsReasonsN);
    setPointsReasonsSel(pointsReasonsN.length > 0 ? pointsReasonsN[0] : null);

    await loadDto(patientDtoReasonsN);
    await loadLoyalty(idClient);

    setTimeout(() => {
      const el = document.getElementById("loyalty-patient-dto");
      if (el) el.focus();
    }, 100);*/
  };

  const filterMovements = (show, movs, patientsF, reasonsF) => {
    let movsF = structuredClone(movs);
    if (patientsF && patientsF.value !== "") {
      movsF = movsF.filter((mov) => mov.patient === patientsF.value);
    }
    if (reasonsF && reasonsF.value !== "") {
      movsF = movsF.filter((mov) => mov.description === reasonsF.value);
    }

    setShowAllMovements(show);
    let movementsTableN = structuredClone(movsF);
    if (!show) {
      movementsTableN = movementsTableN.splice(0, MAX_MOVEMENTS);
    }
    setMovementsTable(movementsTableN);
  };

  const onChangePatientDto = (e) => {
    setPatientDto(e);
  };

  const onBlurPatientDto = () => {
    let v = 0;
    if (patientDto !== "") {
      if (patientDto > 100) {
        v = 100;
      } else {
        if (patientDto < 0) {
          v = 0;
        } else {
          v = patientDto;
        }
      }
    }
    setPatientDto(parseInt(v));
  };

  const updatePatientDto = async () => {
    if (patientDtoReasonsSel.text === "") {
      createPopupQuestion(
        "Debe seleccionar un motivo para aplicar descuento especial.",
        removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }

    post("EditarDescuentoPaciente.php", {
      token: userData.token,
      idPaciente: idClient,
      descuento: patientDto,
      motivoDescuento: patientDtoReasonsSel.text,
    });

    createPopupQuestion(
      "Descuento especial actualizado correctamente.",
      removePopupQuestion,
      null,
      "Cerrar",
    );

    onUpdateDto(patientDto);
  };

  const onChangePatientDtoReason = (e) => {
    setPatientDtoReasonsSel(e);
  };

  const onChangePointsReason = (e) => {
    setPointsReasonsSel(e);
  };

  const onChangeNewLoyaltyId = (e) => {
    setNewLoyaltyId(e);
  };

  const onClickAssociate = (row) => {
    if (!row.holder) {
      createPopupQuestion(
        "¿Desea asignar a " + row.patient + " como titular?",
        () => {
          const associatesTableN = associatesTable.map((r) => {
            r.holder = r.id === row.id;
            return r;
          });
          setAssociatesTable(associatesTableN);
          removePopupQuestion();

          rpost("Fidelizacion/AsignarTitular.php", {
            token: userData.token,
            idFidelizacion: loyId,
            idPaciente: row.patientId,
            idOptica: selectedOptic.id,
          });
        },
        removePopupQuestion,
        "Asignar",
        "Cancelar",
      );
    }
  };

  const deleteAssociate = (id) => {
    const associate = associatesTable.find((assoc) => assoc.id === id);
    if (associate) {
      if (associate.holder) {
        createPopupQuestion(
          "No se puede eliminar al titular de una tarjeta.",
          removePopupQuestion,
          null,
          "Cerrar",
        );
      } else {
        createPopupQuestion(
          "¿Desea eliminar a " + associate.patient + " como asociado?",
          async () => {
            const associatesTableN = associatesTable.filter((assoc) => {
              return assoc.id != id;
            });
            setAssociatesTable(associatesTableN);
            removePopupQuestion();

            await rpost("Fidelizacion/BajaAsociado.php", {
              token: userData.token,
              idAsociadoFidelizacion: id,
              idFidelizacion: loyId,
              idOptica: selectedOptic.id,
            });

            if (associate.patientId == idClient) {
              setLoyId(-1);
              setLoyaltyId("");
              setPointsConv("");
              await loadLoyalty(idClient);
              onUpdateLoyaltyPoints("-");
            }
          },
          removePopupQuestion,
          "Eliminar",
          "Cancelar",
        );
      }
    }
  };

  const onSelectAddAssociate = (e) => {
    setAddAssociate(e);
  };

  const onLinkPatient = () => {
    if (addAssociate.codigo !== "") {
      window.open(`/patient-datos/${addAssociate.idPaciente}`);
    }
  };

  const onAddAssociate = async () => {
    if (addAssociate) {
      const pos = associatesTable.findIndex(
        (item) => item.patientId == addAssociate.idPaciente,
      );
      if (pos === -1) {
        const response = await rpost("Fidelizacion/AltaAsociado.php", {
          token: userData.token,
          idFidelizacion: loyId,
          idPaciente: addAssociate.idPaciente,
          idOptica: selectedOptic.id,
        });

        if (response.error !== "") {
          createPopupQuestion(
            response.error,
            removePopupQuestion,
            null,
            "Cerrar",
          );
        } else {
          const assoc = {
            id: response.idAsociadoFidelizacion,
            patientId: addAssociate.idPaciente,
            code: addAssociate.codigo,
            nif: addAssociate.nif,
            patient: addAssociate.nombre + " " + addAssociate.apellidos,
            birthDate: addAssociate.fechaNacimiento,
            holder: false,
          };
          const associatesTableN = structuredClone(associatesTable);
          associatesTableN.push(assoc);
          setAssociatesTable(associatesTableN);
          setAddAssociate(null);
        }
      }
    }
  };

  const addCurrentPatientAsAssociate = async (idFid) => {
    await rpost("Fidelizacion/AltaAsociado.php", {
      token: userData.token,
      idFidelizacion: idFid,
      idPaciente: idClient,
      idOptica: selectedOptic.id,
    });
    setLoyId(idFid);
    setLoyaltyId(newLoyaltyId);
    loadLoyalty(idClient);
  };

  const onShowAddAssociate = (show) => {
    setShowAddAssociate(show);
    if (!show) {
      setAddAssociate(null);
    }
  };

  const onChangePointsAdd = (p) => {
    setPointsAdd(p);
  };

  const openNewIdPopup = (show) => {
    let popupNewIdN = null;
    if (show) {
      popupNewIdN = {
        newId: loyaltyId,
      };
      setTimeout(() => focusElement(10000), 100);
    }
    setPopupNewId(popupNewIdN);
  };

  const onChangeNewId = (e) => {
    setPopupNewId({
      ...popupNewId,
      newId: e,
    });
  };

  const onApplyNewId = async () => {
    if (popupNewId.newId !== loyaltyId) {
      if (popupNewId.newId === "") {
        createPopupQuestion(
          "El nuevo ID de fidelización no puede estar vacío.",
          removePopupQuestion,
          null,
          "Cerrar",
        );
        return;
      }

      const response = await rpost(
        "Fidelizacion/CambiarCodigoFidelizacion.php",
        {
          token: userData.token,
          idFidelizacion: loyId,
          nuevoCodigo: popupNewId.newId,
          idOptica: selectedOptic.id,
        },
      );
      if (response.existe) {
        createPopupQuestion(
          "El nuevo ID de fidelización ya está en uso.",
          removePopupQuestion,
          null,
          "Cerrar",
        );
      } else {
        setLoyaltyId(popupNewId.newId);
        setPopupNewId(null);
      }
    } else {
      setPopupNewId(null);
    }
  };

  const onRemoveLoyalty = () => {
    createPopupQuestion(
      "Está a punto de eliminar el ID de fidelización de manera completa. Dicho ID se liberará y se eliminarán sus asociados. ¿Desea continuar?",
      async () => {
        await rpost("Fidelizacion/BajaFidelizacion.php", {
          token: userData.token,
          idFidelizacion: loyId,
          idOptica: selectedOptic.id,
        });
        loadLoyalty(idClient);
        removePopupQuestion();
      },
      removePopupQuestion,
      "Eliminar",
      "Cancelar",
    );
  };

  const createLoyalty = async () => {
    if (newLoyaltyId !== "") {
      const response = await rpost("Fidelizacion/AltaFidelizacion.php", {
        token: userData.token,
        idCliente: idClient,
        codigo: newLoyaltyId,
        idOptica: selectedOptic.id,
        nombreEmpleado: userData.nombre + " " + userData.apellidos,
      });
      if (response.error !== "") {
        createPopupQuestion(
          response.error,
          removePopupQuestion,
          null,
          "Cerrar",
        );
        return;
      }
      if (response.existe) {
        const asociados = response.existeClientes.reduce((acc, curr) => {
          return acc + curr.nombreOptica + " - " + curr.nombreApellidos + "\n";
        }, "");
        createPopupQuestion(
          "El ID de fidelización ya está en uso.\n\nAsociados:\n\n" + asociados,
          () => {
            addCurrentPatientAsAssociate(response.idFidelizacion);
            removePopupQuestion();
          },
          removePopupQuestion,
          "Añadir",
          "Cancelar",
        );
      } else {
        await loadLoyalty(idClient);
      }
    }
  };

  const assignPoints = async () => {
    if (pointsReasonsSel.id === "") {
      createPopupQuestion(
        "Debe seleccionar un motivo para asignar puntos.",
        removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }
    if (pointsAdd == 0) {
      createPopupQuestion(
        "Debe indicar puntos para asignarlos manualmente.",
        removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }
    if (pointsAdd + pointsConv < 0) {
      createPopupQuestion(
        "El cliente no puede tener puntos negativos.",
        removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }
    await rpost("Fidelizacion/GenerarMovimiento.php", {
      token: userData.token,
      idCliente: idClient,
      idFidelizacion: loyId,
      numeroTicket: -1,
      opticaGestion: selectedOptic.id,
      empleado: userData.nombre + " " + userData.apellidos,
      tipoMovimiento: "APM",
      descripcion: pointsReasonsSel.text,
      puntos: pointsAdd,
      totalPuntos: pointsConv,
    });
    loadLoyalty(idClient);
    setPointsAdd(0);
    setPointsReasonsSel(pointsReasons[0]);
    inputIntRef.current.restart();
    onUpdateLoyaltyPoints(pointsConv + pointsAdd);
  };

  const createPatientsFilter = (movs) => {
    const patients = movs.reduce((acc, curr) => {
      const pos = acc.findIndex((item) => item.text == curr.patient);
      if (pos === -1) {
        acc.push({
          value: curr.patient,
          text: curr.patient,
        });
      }
      return acc;
    }, []);

    patients.sort((a, b) => (a.text > b.text ? 1 : -1));

    patients.unshift({
      value: "",
      text: "",
    });
    setPatientsFilter(patients);
  };

  const createReasonsFilter = (movs) => {
    const reasons = movs.reduce((acc, curr) => {
      const pos = acc.findIndex((item) => item.value == curr.description);
      if (pos === -1) {
        const typeName = MOVEMENT_TYPES[curr.description];
        acc.push({
          value: curr.description,
          text: typeName
            ? `${curr.description} - ${typeName.toUpperCase()}`
            : curr.description,
        });
      }
      return acc;
    }, []);

    reasons.sort((a, b) => (a.text > b.text ? 1 : -1));

    reasons.unshift({
      value: "",
      text: "",
    });
    setReasonsFilter(reasons);
  };

  const onChangePatientsFilter = (e) => {
    setPatientsFilterSel(e);

    filterMovements(showAllMovements, movements, e, reasonsFilterSel);
  };

  const onChangeReasonsFilter = (e) => {
    setReasonsFilterSel(e);

    filterMovements(showAllMovements, movements, patientsFilterSel, e);
  };

  useEffect(() => {
    if (show === true) {
      loadScreen();
    }
  }, [show]);

  return (
    show && (
      <div className="popup-container popup-normal popup-loyalty">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">Fidelización</div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={() => onClose()}
            />
          </div>
          <div className="popup-body">
            <div className="popup-container-block">
              <span className="section-content-title">
                Descuentos del paciente
              </span>
              <div className="section-content-sep" />
              <div className="popup-row">
                <div className="label">DTO especial (%)</div>
                <InputData
                  tabIndex={1}
                  id="loyalty-patient-dto"
                  type="type-only-numbers"
                  size={7}
                  maxLength={12}
                  input={patientDto}
                  onChange={onChangePatientDto}
                  onBlur={onBlurPatientDto}
                />
                <SepH size={10} />
                <div className="label">Motivo DTO</div>
                <Dropdown
                  tabIndex={2}
                  id="loyalty-patient-reason"
                  disabled={false}
                  optionList={patientDtoReasons}
                  size={3}
                  op={patientDtoReasonsSel?.id}
                  onChange={onChangePatientDtoReason}
                />
                <SepH size={10} />
                <ButtonIconH
                  text="Actualizar"
                  disabled={false}
                  onClick={updatePatientDto}
                />
              </div>
            </div>
            <div className="popup-container-block">
              <span className="section-content-title">Fidelización</span>
              <div className="section-content-sep" />
              <div className="popup-container-block-loyalty">
                <div className="loyalty-left">
                  <div className="popup-row popup-row-loyalty-info">
                    <div className="loyalty-info">
                      <div className="label">Id de fidelización</div>
                      <InputData
                        tabIndex={3}
                        id="loyalty-id"
                        type="type-only-numbers"
                        size={7}
                        maxLength={12}
                        input={loyaltyId === "" ? newLoyaltyId : loyaltyId}
                        onChange={onChangeNewLoyaltyId}
                        inactive={loyaltyId !== ""}
                      />
                      {loyaltyId !== "" && (
                        <img
                          className="loyalty-icon"
                          src="/images/support-extra/editar.svg"
                          onClick={() => openNewIdPopup(true)}
                        />
                      )}
                      {loyaltyId !== "" && (
                        <img
                          className="loyalty-icon"
                          src="/images/remove-blue.svg"
                          onClick={onRemoveLoyalty}
                        />
                      )}
                      {loyaltyId === "" && (
                        <img
                          className="loyalty-icon"
                          src="/images/save-blue.svg"
                          onClick={createLoyalty}
                        />
                      )}
                      <SepH size={10} />
                      <div className="label">Puntos</div>
                      <InputData
                        tabIndex={4}
                        id="loyalty-points"
                        size={7}
                        maxLength={12}
                        input={formatNumber(pointsConv || 0)}
                        onChange={null}
                        inactive={true}
                      />
                    </div>
                    <div className="loyalty-points-assignation">
                      <InputFloat
                        ref={inputIntRef}
                        initValue={pointsAdd}
                        onChange={(p) => onChangePointsAdd(p)}
                      />
                      <div className="cell-extra cell-extra-label">
                        <span className="label">Motivo</span>
                      </div>
                      <Dropdown
                        tabIndex={5}
                        id="loyalty-patient-reason"
                        disabled={false}
                        optionList={pointsReasons}
                        size={2}
                        op={pointsReasonsSel?.id}
                        onChange={onChangePointsReason}
                      />
                      <ButtonIconH
                        text="Aplicar"
                        disabled={loyaltyId === ""}
                        onClick={assignPoints}
                      />
                    </div>
                  </div>
                  <div className="loyalty-movements-title opt-table-title">
                    <span>
                      Asociados al ID de fidelización ({associatesTable.length})
                    </span>
                  </div>
                  <div
                    className="popup-row table-scrollable"
                    id="loyalty-associates-table"
                  >
                    <DataTable
                      columns={associatesColumns}
                      data={associatesTable}
                      className="custom-datatable non-interactive"
                      noDataComponent="No hay datos disponibles."
                    />
                  </div>
                  {showAddAssociate && (
                    <div className="popup-row popup-row-center popup-loyalty-add-associate">
                      <div className="label">Cod paciente</div>
                      <InputSearch
                        id="codigorec-loyalty"
                        size={1}
                        tabIndex={10}
                        link={true}
                        code={true}
                        op={addAssociate ? addAssociate.codigo : ""}
                        onSelect={onSelectAddAssociate}
                        onClickLink={onLinkPatient}
                        showCode={true}
                      />
                      <ButtonIconH
                        text="Añadir"
                        disabled={false}
                        small={true}
                        onClick={onAddAssociate}
                      />
                      <ButtonIconH
                        text="Cerrar"
                        disabled={false}
                        small={true}
                        onClick={() => onShowAddAssociate(false)}
                      />
                    </div>
                  )}
                  {loyaltyId !== "" && (
                    <div className="popup-row popup-row-center">
                      <div className="load-more">
                        <img
                          src="/images/load.svg"
                          loading="lazy"
                          width="22"
                          height="22"
                          alt="load"
                          className="vectors-wrapper-76"
                          onClick={() => onShowAddAssociate(!showAddAssociate)}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="loyalty-movements-title opt-table-title">
                <span>
                  Listado de movimientos ({movementsTable.length} de{" "}
                  <span className="listado-total">{movements.length}</span>)
                </span>
              </div>
              <div className="popup-row">
                <div className="label">Paciente</div>
                <Dropdown
                  tabIndex={6}
                  id="loyalty-patients-filter"
                  disabled={false}
                  optionList={patientsFilter}
                  size={3}
                  op={patientsFilterSel?.value}
                  onChange={onChangePatientsFilter}
                />
                <div className="label">Motivo</div>
                <Dropdown
                  tabIndex={7}
                  id="loyalty-reasons-filter"
                  disabled={false}
                  optionList={reasonsFilter}
                  size={3}
                  op={reasonsFilterSel?.value}
                  onChange={onChangeReasonsFilter}
                />
              </div>
              <div
                className="popup-row table-scrollable"
                id="loyalty-movements-table"
              >
                <DataTable
                  columns={movementsColumns}
                  data={movementsTable}
                  className="custom-datatable non-interactive"
                  noDataComponent="No hay datos disponibles."
                />
                {Object.entries(MOVEMENT_TYPES).map(([code, name]) => (
                  <TooltipBox
                    key={code}
                    id={`loyalty-movement-type-${code}`}
                    content={<div className="cell">{name}</div>}
                  ></TooltipBox>
                ))}
              </div>
              {movementsTable.length > 0 && (
                <div className="popup-row-buttons popup-row-more">
                  <ButtonIconH
                    text={showAllMovements ? "Ver menos" : "Ver más"}
                    small={true}
                    disabled={false}
                    onClick={() =>
                      filterMovements(
                        !showAllMovements,
                        movements,
                        patientsFilterSel,
                        reasonsFilterSel,
                      )
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {popupNewId && (
          <div className="popup-container popup-normal popup-loyalty-new-id">
            <div className="popup-message">
              <div className="popup-header">
                <div className="popup-title">EDITAR ID FIDELIZACIÓN</div>
                <img
                  src="/images/close-white.svg"
                  loading="lazy"
                  alt=""
                  className="popup-close"
                  onClick={() => openNewIdPopup(false)}
                />
              </div>
              <div className="popup-body">
                <div className="popup-row popup-row-center">
                  <div className="label">Nuevo ID de fidelización</div>
                  <InputData
                    tabIndex={10000}
                    id="loyalty-new-id"
                    type="type-only-numbers"
                    size={7}
                    maxLength={12}
                    input={popupNewId.newId}
                    onChange={onChangeNewId}
                    onEnter={onApplyNewId}
                  />
                </div>
                <div className="popup-row-buttons popup-row-center">
                  <ButtonIconH
                    text="Editar"
                    disabled={false}
                    onClick={onApplyNewId}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};

/*

const patientDtoReasonsOr = [
  {
    id: "CLIENTE DE TODA LA VIDA",
    text: "CLIENTE DE TODA LA VIDA",
  },
  {
    id: "FAMILIAR DE SOCIO",
    text: "FAMILIAR DE SOCIO",
  },
  {
    id: "DISCAPACIDAD LEY 2025/77",
    text: "DISCAPACIDAD LEY 2025/77",
  },
];

const pointsReasonsOr = [
  {
    id: "NUEVO CLIENTE",
    text: "NUEVO CLIENTE",
  },
  {
    id: "AJUSTE POR ABONO",
    text: "AJUSTE POR ABONO",
  },
  {
    id: "AJUSTE POR ERROR",
    text: "AJUSTE POR ERROR",
  },
];

const associatesListOr = [
  {
    id: 1,
    patientId: 3,
    code: "19901",
    nif: "76037888F",
    patient: "ALEJANDRO CRISTO GARCÍA",
    birthDate: "1984-02-06",
    holder: false,
  },
  {
    id: 2,
    patientId: 3,
    code: "19902",
    nif: "76037888G",
    patient: "GUILLERMO CRISTO HERNÁNDEZ",
    birthDate: "1990-02-06",
    holder: true,
  },
  {
    id: 3,
    patientId: 3,
    code: "19903",
    nif: "76037888H",
    patient: "LUZ DEL CARMEN CRISTO HERNÁNDEZ",
    birthDate: "1991-02-06",
    holder: false,
  },
  {
    id: 4,
    patientId: 3,
    code: "19904",
    nif: "76037888I",
    patient: "RODRIGO CRISTO HERNÁNDEZ",
    birthDate: "1992-02-06",
    holder: false,
  },
  {
    id: 5,
    patientId: 3,
    code: "19901",
    nif: "76037888F",
    patient: "ALEJANDRO CRISTO GARCÍA",
    birthDate: "1984-02-06",
    holder: false,
  },
  {
    id: 6,
    patientId: 3,
    code: "19902",
    nif: "76037888G",
    patient: "GUILLERMO CRISTO HERNÁNDEZ",
    birthDate: "1990-02-06",
    holder: true,
  },
  {
    id: 7,
    patientId: 3,
    code: "19903",
    nif: "76037888H",
    patient: "LUZ DEL CARMEN CRISTO HERNÁNDEZ",
    birthDate: "1991-02-06",
    holder: false,
  },
  {
    id: 8,
    patientId: 3,
    code: "19904",
    nif: "76037888I",
    patient: "RODRIGO CRISTO HERNÁNDEZ",
    birthDate: "1992-02-06",
    holder: false,
  },
];

const movementsListOr = [
  {
    id: 1,
    code: "19902",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "11",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-01",
    points: 1000,
    total: 3000,
  },
  {
    id: 2,
    code: "19901",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "12",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "ASIGNACIÓN POR NUEVO CLIENTE",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-02",
    points: 500,
    total: 2000,
  },
  {
    id: 3,
    code: "19903",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "13",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-03",
    points: -50,
    total: 400,
  },
  {
    id: 4,
    code: "19902",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "11",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-01",
    points: 1000,
    total: 3000,
  },
  {
    id: 5,
    code: "19901",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "12",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "ASIGNACIÓN POR NUEVO CLIENTE",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-02",
    points: 500,
    total: 2000,
  },
  {
    id: 6,
    code: "19903",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "13",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-03",
    points: -50,
    total: 400,
  },
  {
    id: 7,
    code: "19902",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "11",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-01",
    points: 1000,
    total: 3000,
  },
  {
    id: 8,
    code: "19901",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "12",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "ASIGNACIÓN POR NUEVO CLIENTE",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-02",
    points: 500,
    total: 2000,
  },
  {
    id: 9,
    code: "19903",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "13",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-03",
    points: -50,
    total: 400,
  },
  {
    id: 10,
    code: "19902",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "11",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-01",
    points: 1000,
    total: 3000,
  },
  {
    id: 11,
    code: "19901",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "12",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "ASIGNACIÓN POR NUEVO CLIENTE",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-02",
    points: 500,
    total: 2000,
  },
  {
    id: 12,
    code: "19903",
    patient: "ALEJANDRO CRISTO GARCÍA",
    operation: "13",
    optic: "ÓPTICA CÁCERES",
    description: "PUNTOS DE BIENVENIDA",
    reason: "",
    agent: "ADMINISTRADOR ÓPTICA",
    date: "2025-09-03",
    points: -50,
    total: 400,
  },
];

*/
